//hook
import useWindowDimension from "../hook/use.window.dimension";

//component
import Footer from "../footer/footer";
import SideBar from "../bar/side.bar";
import BottomNavBar from "../bar/bottom.bar";
import Header from "../header/header";
import CommonBanner from "../common/common.banner";
import { useEffect } from "react";
import scrollToTop from "../../helpers/scroll.to.top";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoginModal from "../../pages/login";
import { getCartInfo } from "../../redux/reducer/cart.reducer";
import {
  closeFullLoading,
  getCartCount,
  getCategoryList,
  getRole,
  getToken,
  getUserId,
  getUsername,
} from "../../redux/reducer/common.reducer";
import CommonLoading from "../common/common.loading";

export default function MainLayout(props) {
  const dispatch = useDispatch();
  const { className } = props;
  const { pathname } = useLocation();
  const { isOpenLoginModal } = useSelector((state) => state.modal);
  const { token, username, isOpenFullLoading } = useSelector(
    (state) => state.common
  );

  useEffect(() => {
    if (pathname.includes("/shop")) {
      return;
    }

    scrollToTop();
  }, [pathname]);

  useEffect(() => {
    dispatch(getRole());
    dispatch(getToken());
    dispatch(getUserId());
    dispatch(getUsername());
    dispatch(getCategoryList());
    dispatch(closeFullLoading());
  }, [token]);

  useEffect(() => {
    if (token && username) {
      dispatch(getCartInfo());
      dispatch(getCartCount());
    }
  }, [token, username]);

  useEffect(() => {
    const header = document.querySelector(".fixed-container");

    const handleScroll = () => {
      if (window.scrollY > 100) {
        header.classList.add("--box-shadow");
      } else {
        header.classList.remove("--box-shadow");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isOpenFullLoading) {
      scrollToTop();
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpenFullLoading]);

  return (
    <main>
      <section className="fixed-container">
        <CommonBanner />
        <Header />
      </section>
      {/* {width > 991 && <SideBar />} */}
      <section className={`content-container ${className ?? ""}`}>
        {props.children}
      </section>
      <Footer />
      {/* {width < 991 && <BottomNavBar />} */}
      {isOpenLoginModal && <LoginModal />}
      {isOpenFullLoading && <CommonLoading />}
    </main>
  );
}
